// @flow

import _ from 'lodash';
import React, { PureComponent } from 'react';
import { BOOLEAN_STRINGS, type BooleanStringType } from 'client/constants/globals';

const ONE_SECOND_IN_MILLISECONDS = 1000;
const ONE_MINUTE_IN_MILLISECONDS = 6e4;
const ONE_HOUR_IN_MILLISECONDS = 36e5;
const HOURS_PER_DAY = 24;
const DAY = 'day';
const HOUR = 'hour';

type Props = {
  displayOneLine?: boolean,
  displayFullTime?: BooleanStringType,
  countdownEnd: Date,
  timerMessage: string,
};

type State = {
  timeString: string,
};

type CountdownTimeStringType = {
  targetDate: Date,
  displayFullTime?: boolean,
};

const addPadding = (time: number) => `${time < 10 ? '0' : ''}${time}`;

export const pluralize = (unit: string, count: number) => (count <= 1 ? unit : `${unit}s`);

const getPluralizeUnit = (word: string, count: number) => `${count} ${pluralize(word, count)}`;

export const getCountdownTimeString = ({
  targetDate,
  displayFullTime = false,
}: CountdownTimeStringType) => {
  const timeUntilEndOfOEP = targetDate - new Date();
  const days = Math.floor(timeUntilEndOfOEP / ONE_HOUR_IN_MILLISECONDS / HOURS_PER_DAY);
  const hours = addPadding(
    Math.floor((timeUntilEndOfOEP / ONE_HOUR_IN_MILLISECONDS) % HOURS_PER_DAY),
  );
  const minutes = addPadding(
    Math.floor((timeUntilEndOfOEP % ONE_HOUR_IN_MILLISECONDS) / ONE_MINUTE_IN_MILLISECONDS),
  );
  const seconds = addPadding(
    Math.floor((timeUntilEndOfOEP % ONE_MINUTE_IN_MILLISECONDS) / ONE_SECOND_IN_MILLISECONDS),
  );
  if (Number(days) === 0) {
    return `Just ${getPluralizeUnit(HOUR, Number(hours))} left!`;
  }
  return displayFullTime
    ? [days, hours, minutes, seconds].join(':')
    : `Just ${getPluralizeUnit(DAY, Number(days))} and ${getPluralizeUnit(
      HOUR,
      Number(hours),
    )} left!`;
};

class CountdownTimer extends PureComponent<Props, State> {
  static defaultProps = {
    displayOneLine: false,
    displayFullTime: BOOLEAN_STRINGS.FALSE,
    countdownEnd: new Date('2020-12-15T23:59:59-08:00'),
    timerMessage: 'Open Enrollment ends Dec. 15th',
  };

  constructor(props: Props) {
    super(props);

    this.currentTime = Date.now();
    this.oepEnd = new Date(this.props.countdownEnd);
    this.twoWeeksBeforeOEPEnd = new Date(2020, 11, 1);
    this.state = {
      timeString: getCountdownTimeString({
        targetDate: this.oepEnd,
        displayFullTime: _.isBoolean(this.props.displayFullTime),
      }),
    };

    setInterval(() => {
      this.setState({
        timeString: getCountdownTimeString({
          targetDate: this.oepEnd,
          displayFullTime: _.isBoolean(this.props.displayFullTime),
        }),
      });
    }, 1000);
  }

  currentTime: number;
  oepEnd: Date;
  props: Props;
  twoWeeksBeforeOEPEnd: Date;

  render() {
    const boxStyle = this.twoWeeksBeforeOEPEnd > this.currentTime ? 'orange-box' : 'red-box';
    const styles = `${boxStyle} text-center flex-row center`;
    const hasOEPEnded = this.oepEnd - this.currentTime <= 0;

    if (hasOEPEnded) return <div className="transparent-box" />;

    return this.props.displayOneLine ? (
      <div className={styles}>
        <div className="text-box">
          <span>{this.props.timerMessage} </span>
          <span className="bold">{this.state.timeString}</span>
        </div>
      </div>
    ) : (
      <div className={styles}>
        <div className="text-box">
          <div>
            <p>{this.props.timerMessage}</p>
            <p className="bold">{this.state.timeString}</p>
          </div>
        </div>
      </div>
    );
  }
}

export default CountdownTimer;
